import { Accordion } from 'components';
import { useTranslation } from 'react-i18next';
import {
  FormControl,
  Icon,
  FormAutocomplete,
  FormSelectOutsideTag,
} from 'components/ui';
import { SInput } from './styled';

export default function PatientsCareTeams({
  careTeams,
  loadingCareTeams,
  loadMoreCareTeams,
  setSearchCareTeams,
  changeCareTeamDialog,
  onCareTeamsChange,
  form,
  selectedCareTeamId,
  showGroups = false,
  patientGroups,
  loadMoreGroups,
  loadingGroups,
  setSearchGroups,
  isRequired = true,
}) {
  const { t } = useTranslation();

  return (
    <Accordion
      title={t('Patients care teams') + (isRequired ? ' *' : '')}
      startAdornment={<Icon icon="hands-heart" />}
    >
      <FormControl label={t('Care teams') + (isRequired ? ' *' : '')}>
        <FormAutocomplete
          name="careTeams"
          options={careTeams}
          loading={loadingCareTeams || changeCareTeamDialog?.isOpen}
          getOptionValue={(option) => option?.id}
          getOptionLabel={(option) => option?.name}
          onChange={(e, v) => onCareTeamsChange(v, form)}
          inputOnChange={(searchValue) => { setSearchCareTeams && setSearchCareTeams(searchValue || ''); }}
          onScroll={loadMoreCareTeams}
          placeholder={t('Select care team')}
          renderInput={(params) => (
            <SInput
              {...params}
              placeholder={t('Care teams')}
              variant="outlined"
            />
          )}
        />
      </FormControl>
      {selectedCareTeamId && showGroups && (
        <FormControl label={t('Patient groups')}>
          <FormSelectOutsideTag
            name="patientGroups"
            getOptionLabel={(o) => o?.title}
            getOptionValue={(o) => o.id}
            boxStyle={{ width: '100%' }}
            isOptionEqualToValue={(option, value) => option.id === value.id}
            options={patientGroups}
            onScroll={loadMoreGroups}
            loading={loadingGroups}
            inputOnChange={setSearchGroups}
            placeholder={t('Choose patient groups (optional)')}
            getTag={(item) => ({ title: item?.title, value: item?.id })}
          />
        </FormControl>
      )}
    </Accordion>
  );
}
